import React from 'react';
import { Grid } from '@material-ui/core';

import DriverFeature from '../DriverFeature';
import UnlimitedKmFeature from '../UnlimitedKmFeature';
import useCar from '../../../../../../context/useCar';

const Features = () => {
	const {
		carDetails: { car },
	} = useCar();

	const isDriverAvailable = car.office.driver || false;
	const isUnlimitedKmAvailable = car.unlimited_km || false;

	return (
		<Grid container spacing={1} wrap="nowrap" justify="center">
			{isDriverAvailable && (
				<Grid item xs={6} md={3}>
					<DriverFeature />
				</Grid>
			)}

			{isUnlimitedKmAvailable && (
				<Grid item xs={6} md={3}>
					<UnlimitedKmFeature />
				</Grid>
			)}
		</Grid>
	);
};

export default Features;
